<form [formGroup]="form" [formEditablePermission]="form" class="container-box">
  <div class="px-3 py-2 border-bottom">
    <div class="d-flex align-items-center gap-3">
      <div class="title">
        <img [src]="channel?.logoColor" [alt]="channel?.friendlyName" />
      </div>
      <div class="flex-fill"></div>
      <button
        type="button"
        class="btn btn-secondary-warning"
        *ngIf="isAirBnBV2 && isNonProductionEnvironment"
        (click)="onPrepareTestListing()"
        [disabled]="isPreparingTestListing || (isUpdating$ | async) || form.invalid || (1 | isReadonlyRole)"
      >
        <span class="spinner-border spinner-border-sm mr-2" *ngIf="isPreparingTestListing"></span>
        <ng-container *ngIf="!isPreparingTestListing" i18n>Prepare Test Listing</ng-container>
        <ng-container *ngIf="isPreparingTestListing" i18n>Preparing...</ng-container>
      </button>
      <button
        type="button"
        class="btn btn-secondary-light"
        *ngIf="(channel | isAirBnBV2) && (isBoolean | call : isAirBnBV2PropertyVisible)"
        (click)="onToggleAirBnBVisible()"
        [disabled]="(isUpdating$ | async) || form.invalid || (1 | isReadonlyRole) || isAirbnbDeleted()"
      >
        <ng-container *ngIf="isAirBnBV2PropertyVisible">
          <i class="fal fa-eye"></i><ng-container i18n>Visible</ng-container>
        </ng-container>
        <ng-container *ngIf="!isAirBnBV2PropertyVisible">
          <i class="fal fa-eye-slash"></i><ng-container i18n>Not Visible</ng-container>
        </ng-container>
      </button>
      <app-bdc-listing-status *ngIf="isBDC" [propertyId]="connection.propertyId"></app-bdc-listing-status>

      <!-- Dropdown button -->
      <div
        class="btn-group"
        dropdown
        placement="bottom"
        [isDisabled]="1 | isReadonlyRole"
        *ngIf="connection.rental || isAirBnBV1 || isAirBnBV2 || hasChannelContentApi"
      >
        <button type="button" class="btn btn-secondary-warning dropdown-toggle" dropdownToggle>
          <span class="cs-icon cs-icon-bolt"></span> <ng-container i18n>Actions</ng-container>
        </button>
        <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
          <li *ngIf="!connection.rental && !connection.roomMissing">
            <button type="button" (click)="onLink()" [disabled]="connection.isPlaceholderRoom">
              <i class="fal fa-link"></i> <ng-container i18n>Link</ng-container>
            </button>
          </li>
          <ng-container *ngIf="connection.rental">
            <li>
              <button type="button" (click)="onUnlink()">
                <i class="fal fa-unlink"></i> <ng-container i18n>Unlink</ng-container>
              </button>
            </li>
            <li>
              <button type="button" (click)="onPushRates()">
                <i class="fal fa-arrow-up"></i> <ng-container i18n>Push Rates</ng-container>
              </button>
            </li>
            <li>
              <button type="button" (click)="onPushAvailability()">
                <i class="fal fa-arrow-up"></i> <ng-container i18n>Push Availability</ng-container>
              </button>
            </li>
            <li *ngIf="!isTiketLikeChannel">
              <button type="button" (click)="onImportBookings()">
                <i class="fal fa-arrow-down"></i> <ng-container i18n>Import Bookings</ng-container>
              </button>
            </li>
            <!-- QA/testing only: stage has no cron pulling the BDC booking event feed,
                 and the regular Import Bookings above cannot apply modifications or
                 cancellations. Hidden on production. -->
            <li *ngIf="isBDC && isNonProductionEnvironment">
              <button type="button" (click)="onImportNewBookings()">
                <i class="fal fa-arrow-down"></i> <ng-container i18n>Import Booking Events (QA)</ng-container>
              </button>
            </li>
          </ng-container>

          <ng-container *ngIf="isAirBnBV2 || isAirBnBV1">
            <li class="dropdown-divider"></li>
            <li>
              <button *ngIf="hasBookingPreferences" type="button" (click)="onUpdateBookingPrefAirBnB()">
                <i class="fal fa-check-circle"></i> <ng-container i18n>Booking Preferences</ng-container>
              </button>
            </li>
            <li *ngIf="isAirBnBV2">
              <button *ngIf="hasBookingSettings" type="button" (click)="onUpdateBookingSettingsAirBnBV2()">
                <i class="fal fa-check-circle"></i> <ng-container i18n>Booking Settings</ng-container>
              </button>
            </li>
            <li *ngIf="isAirBnBV2">
              <button *ngIf="hasPriceSettings" type="button" (click)="onUpdatePriceSettingsAirBnBV2()">
                <i class="fal fa-check-circle"></i> <ng-container i18n>Price Settings</ng-container>
              </button>
            </li>
            <li *ngIf="isAirBnBV2">
              <button *ngIf="hasTaxSettings" type="button" (click)="onUpdateTaxSettingsAirBnBV2()">
                <i class="fal fa-check-circle"></i> <ng-container i18n>Tax Settings</ng-container>
              </button>
            </li>
          </ng-container>
          <ng-container *ngIf="isAirBnBV2 && (isTokeetPaidSub$ | async)">
            <li class="dropdown-divider"></li>
            <li>
              <button type="button" (click)="onUpdateSyncCategoryAirBnBV2()">
                <i class="fal fa-exchange"></i> <ng-container i18n>Change Synchronization</ng-container>
              </button>
            </li>
            <li>
              <button type="button" (click)="onSyncImageAirBnBV2()">
                <i class="fal fa-images"></i> <ng-container i18n>Sync Images</ng-container>
              </button>
            </li>
            <li>
              <button type="button" (click)="onUpdateListingDetailsAirBnBV2()">
                <i class="fal fa-list"></i> <ng-container i18n>Update Listing Details</ng-container>
              </button>
            </li>
            <li>
              <button type="button" (click)="onPushRoomsAirBnBV2()">
                <i class="fal fa-bed"></i> <ng-container i18n>Sync Rooms</ng-container>
              </button>
            </li>
            <li class="dropdown-divider"></li>
            <li>
              <button type="button" (click)="onDeleteListingAirBnBV2()" class="text-danger">
                <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete AirBnb Listing</ng-container>
              </button>
            </li>
          </ng-container>

          <ng-container *ngIf="hasChannelContentApi">
            <li class="dropdown-divider"></li>
            <li>
              <button type="button" (click)="onEditListDetails()">
                <i class="fal fa-edit"></i> <ng-container i18n>Edit Listing Details</ng-container>
              </button>
            </li>
            <li *ngIf="isBDC">
              <button type="button" (click)="onBDCViewSummary()">
                <i class="fal fa-file-alt"></i> <ng-container i18n>View Summary</ng-container>
              </button>
            </li>
          </ng-container>
        </ul>
      </div>

      <button
        type="button"
        class="btn btn-secondary-info"
        (click)="onSave()"
        [disabled]="
          (isUpdating$ | async) ||
          form.invalid ||
          (1 | isReadonlyRole) ||
          connection?.roomMissing ||
          connection?.isPlaceholderRoom
        "
      >
        <i class="cs-icon cs-icon-save"></i>
        <ng-container i18n>Save</ng-container>
      </button>
    </div>
  </div>
  <div class="p-3">
    <div class="row">
      <div class="col-md-6">
        <div class="text-uppercase text-light mb-3" i18n>Channel Information</div>
        <div class="d-flex">
          <app-rental-select
            [multiple]="false"
            placeholder="Linked Rental"
            i18n-placeholder
            [ctrl]="form.get('rental')"
            class="mat-block"
            [excludeSubunits]="true"
          >
          </app-rental-select>
          <a
            href="javascript:;"
            (click)="onRentalDetails(connection.rental)"
            *ngIf="connection.rental"
            class="ml-2 btn btn-light-primary align-input-row-end"
          >
            <i class="cs-icon cs-icon-rental2"></i>
          </a>
        </div>
        <div class="d-flex align-items-center gap-5">
          <div class="d-flex gap-2">
            <i class="cs-icon cs-icon-channels text-info text-xxl mt-1"></i>
            <div>
              <div class="text-light" i18n>Channel</div>
              <div>{{ channel?.friendlyName }}</div>
            </div>
          </div>
          <div class="d-flex gap-2">
            <i class="cs-icon cs-icon-grid-check text-warning text-xxl mt-1"></i>
            <div>
              <div class="text-light" i18n>Type</div>
              <div>{{ connection?.typeText }}</div>
            </div>
          </div>
          <div class="d-flex gap-2">
            <i class="cs-icon cs-icon-calendar-plus text-indigo text-xxl mt-1"></i>
            <div>
              <div class="text-light" i18n>Date Linked</div>
              <div>{{ connection?.linkDate | epoch : 'DD-MMM-YYYY • hh:mm A' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 border-left">
        <div class="text-uppercase text-light mb-3" i18n>Room Information</div>
        <div class="d-grid gap-3" style="grid-template-columns: 1fr 1fr">
          <div class="d-flex gap-2">
            <i class="cs-icon cs-icon-property text-primary text-xxl fa-fw mt-1"></i>
            <div>
              <div class="text-light" i18n>Property Name</div>
              <div>{{ connection.propertyName }}</div>
            </div>
          </div>
          <div class="d-flex gap-2">
            <i class="cs-icon cs-icon-property-number text-primary text-xxl fa-fw mt-1"></i>
            <div>
              <div class="text-light" i18n>Property ID</div>
              <div>{{ connection.propertyId }}</div>
            </div>
          </div>

          <div class="d-flex gap-2">
            <i class="cs-icon cs-icon-room text-indigo text-xl fa-fw mt-1"></i>
            <div>
              <div class="text-light" i18n>Room Name</div>
              <div>{{ connection.roomName }}</div>
            </div>
          </div>
          <div class="d-flex gap-2">
            <i class="cs-icon cs-icon-room text-indigo text-xl fa-fw mt-1"></i>
            <div>
              <div class="text-light" i18n>Room ID</div>
              <div>{{ connection.roomId }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
